(function (Drupal, $) {
  Drupal.behaviors.knowYourBBQ = {
    attach: function attach(context) {
      const updatePosition = (position) => {
        $('.bbq-arrow').attr('style', position);
      }

      const expandAccordionItem = (item) => {
        if (!$(item).parent().hasClass('open')) {
          $(item).closest('.field__field-tray-accordion-items').find('.open').removeClass('open');
        }
        $(item).parent().toggleClass('open');
      }

      const mobileView = 768;
      let slickInitialized = false;

      const position = $(context).find('.field__field-tray-accordion-items .paragraph--type--accordion-item-with-coordinates.open')
        .attr('data-position');
      updatePosition(position);

      const moveToOpenItem = () => {
        const position = $(context).find('.field__field-tray-accordion-items .paragraph--type--accordion-item-with-coordinates.open')
          .attr('data-position');
        updatePosition(position);
      }

      $(context).find('.paragraph--type--accordion-item-with-coordinates').hover(function () {
        if (!slickInitialized) {
          const position = $(this).attr('data-position');
          updatePosition(position);
          const accordion = $(this).find('.field-item__field-accordion-item-heading');
          if (!$(accordion).parent().hasClass('open')) {
            // Close all accordions.
           // $(this).closest('.field__field-tray-accordion-items').find('.open').removeClass('open');
          }
        }
      }, function () {
        if (!slickInitialized) {
          moveToOpenItem();
        }
      });

      const updateTrayCarousel = () => {
        if ($(window).width() < mobileView) {
          $(context).find('.field__field-tray-accordion-items').not('.slick-initialized').each(function () {
            $(this).slick({
              dots: true,
              arrows: true,
              slidesToShow: 1,
              infinite: true,
              adaptiveHeight: true,
              appendDots: $(this).closest('.content').find('.dots'),
              prevArrow: $(this).closest('.content').find('.previous-slide'),
              nextArrow: $(this).closest('.content').find('.next-slide'),
            });
          });
          slickInitialized = true;
        } else {
          if (slickInitialized) {
            $(context).find(".field__field-tray-accordion-items")?.slick('unslick');
            slickInitialized = false;
          }
        }
      }

      $(context).find('.field__field-tray-accordion-items').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const element = $('.field__field-tray-accordion-items .field-item__field-tray-accordion-items')
          .get(nextSlide + 1);
        const position = $(element).find('.paragraph')
          .first()
          .data('position');

        updatePosition(position);
      });

      $(window).on('resize orientationchange', function() {
        updateTrayCarousel();
      });

      $(window).ready(function () {
        updateTrayCarousel()
      });

      $(context).find('.paragraph--type--accordion-item-with-coordinates .field-item__field-accordion-item-heading, .paragraph--type--accordion-item-with-coordinates .accordion-icon').click(function () {
        expandAccordionItem(this);
      });
      $(context).find('.paragraph--type--accordion-item-with-coordinates .field-item__field-accordion-item-heading').first().click();
      moveToOpenItem();

    }
  };
})(Drupal, jQuery);
